import { render, staticRenderFns } from "./AdminOtp.vue?vue&type=template&id=5355d71c&scoped=true&"
import script from "./AdminOtp.vue?vue&type=script&lang=js&"
export * from "./AdminOtp.vue?vue&type=script&lang=js&"
import style0 from "./AdminOtp.vue?vue&type=style&index=0&id=5355d71c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5355d71c",
  null
  
)

export default component.exports